var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1436,
    height: 292,
    viewBox: "0 0 1436 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_161_6308",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3H1436V292H0V3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3H1436V292H0V3Z",
    fill: "#FFD9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.4H1436V1.6H0V4.4Z",
    fill: "#FF5A5F",
    mask: "url(#path-1-inside-1_161_6308)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1434.85 3L7.15516 1.17704C6.51457 1.17704 6 0.912799 6 0.587176C6 0.264222 6.51982 0 7.15516 0L1434.85 1.82294C1435.49 1.82294 1436.01 2.08718 1436 2.41281C1436 2.73576 1435.48 2.99733 1434.84 2.99733L1434.85 3Z",
    fill: "#F2F7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5987 80.8601C37.4624 80.8601 37.3235 80.8137 37.2117 80.7184C36.9583 80.5031 36.9284 80.1244 37.1436 79.8737L99.3952 6.55653C99.6105 6.30585 99.9892 6.27315 100.24 6.48841C100.493 6.70368 100.523 7.08242 100.308 7.33311L38.0564 80.6475C37.9365 80.7865 37.7676 80.8601 37.5987 80.8601Z",
    fill: "#F2F7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.613 227.87C100.501 227.87 100.39 227.84 100.292 227.775C100.014 227.598 99.932 227.224 100.109 226.946L222.367 35.9272C222.544 35.6493 222.915 35.5648 223.195 35.7447C223.473 35.9218 223.555 36.2951 223.378 36.573L101.117 227.592C101.003 227.772 100.809 227.867 100.61 227.867L100.613 227.87Z",
    fill: "#F2F7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.702 279.298C189.617 279.298 189.53 279.279 189.448 279.241C189.148 279.099 189.018 278.742 189.159 278.443L314.989 9.36246C315.131 9.06273 315.485 8.93466 315.788 9.07363C316.088 9.21532 316.218 9.57227 316.077 9.872L190.246 278.952C190.146 279.17 189.928 279.298 189.702 279.298Z",
    fill: "#F2F7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1354.34 88.2773C1354.17 88.2773 1354 88.2064 1353.88 88.0675L1287.14 9.7012C1286.93 9.44779 1286.96 9.06904 1287.21 8.8565C1287.46 8.64124 1287.84 8.67121 1288.06 8.92462L1354.8 87.2909C1355.01 87.5443 1354.98 87.923 1354.73 88.1356C1354.62 88.2309 1354.48 88.2773 1354.34 88.2773H1354.34Z",
    fill: "#F2F7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.34 88.2773C1189.17 88.2773 1189 88.2064 1188.88 88.0675L1122.14 9.7012C1121.93 9.44779 1121.96 9.06904 1122.21 8.8565C1122.46 8.64124 1122.84 8.67121 1123.06 8.92462L1189.8 87.2909C1190.01 87.5443 1189.98 87.923 1189.73 88.1356C1189.62 88.2309 1189.48 88.2773 1189.34 88.2773H1189.34Z",
    fill: "#F2F7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M846.401 199.859C846.202 199.859 846.008 199.76 845.894 199.581L726.494 12.0819C726.317 11.8013 726.399 11.4307 726.68 11.2536C726.958 11.0765 727.331 11.1582 727.508 11.4389L846.908 198.938C847.085 199.218 847.003 199.589 846.722 199.766C846.621 199.829 846.51 199.859 846.401 199.859Z",
    fill: "#F2F7FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.02 148C1032.88 148 1032.74 147.929 1032.65 147.798L946.068 11.8286C945.939 11.6251 945.999 11.3564 946.202 11.2279C946.404 11.0995 946.674 11.1588 946.803 11.3623L1033.39 147.332C1033.52 147.536 1033.46 147.804 1033.25 147.933C1033.18 147.978 1033.1 148 1033.02 148Z",
    fill: "#F2F7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M614.948 286.645C614.678 286.645 614.433 286.462 614.367 286.19L546.402 10.6787C546.323 10.3571 546.519 10.0329 546.84 9.95386C547.162 9.87757 547.486 10.071 547.565 10.3926L615.531 285.903C615.61 286.225 615.414 286.549 615.092 286.628C615.043 286.642 614.997 286.645 614.948 286.645Z",
    fill: "#F2F7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M406.46 286.34C406.44 286.34 406.421 286.34 406.402 286.337C406.073 286.308 405.83 286.013 405.863 285.684L431.885 12.3172C431.915 11.9875 432.209 11.7313 432.539 11.7776C432.869 11.8076 433.111 12.1019 433.078 12.4316L407.056 285.798C407.026 286.109 406.765 286.34 406.46 286.34Z",
    fill: "#F2F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgBottom);
export default __webpack_public_path__ + "static/media/Login_BG_bottom.698ee8d9863925429b7f9aeaf47d99e2.svg";
export { ForwardRef as ReactComponent };